import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React from "react";
import { BASE_API_URL } from "store/Me";
import moment from "moment";
import { AdminTable } from "components/shared/AdminTable";

export default function GuestCredentials({ guestId }: { guestId: string }) {
  const { data, isError } = useGetGuestCredentials(guestId);

  if (isError) {
    return <div>There as an error loading credentials.</div>;
  }

  if (data) {
    return (
      <div>
        <AdminTable aria-label="Guest credentials" containerClassName="mt-1">
          <thead>
            <tr>
              <th scope="col">Type</th>
              <th scope="col">Site</th>
              <th scope="col">Credential</th>
              <th scope="col">Timestamps</th>
            </tr>
          </thead>
          <tbody>
              {data.map((credential) => (
                <tr key={credential.id}>
                  <td>{credential.type}</td>
                  <td>
                    <div>{credential.site?.name}</div>
                    <div style={{ fontSize: 11, color: "gray" }}>
                      {credential.site?.id}
                    </div>
                  </td>
                  <td className="w-[300px]">
                    {credential.credential ? (
                      <div
                        style={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          width: 280,
                          overflow: "hidden",
                        }}
                        title={credential.credential}
                      >
                        Credential: {credential.credential}
                      </div>
                    ) : null}
                    {credential.credentialId ? (
                      <div
                        style={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          width: 280,
                          overflow: "hidden",
                        }}
                        title={credential.credentialId}
                      >
                        Credential Id: {credential.credentialId}
                      </div>
                    ) : null}
                  </td>
                  <td>
                    {credential.claimedTimestamp && (
                      <div>
                        Claimed:{" "}
                        {moment(credential.claimedTimestamp).format(
                          "YYYY-MM-DD h:mm A",
                        )}
                      </div>
                    )}
                    {credential.refreshedTimestamp && (
                      <div>
                        Refreshed:{" "}
                        {moment(credential.refreshedTimestamp).format(
                          "YYYY-MM-DD h:mm A",
                        )}
                      </div>
                    )}
                    {credential.deletedTimestamp && (
                      <div>
                        Deleted:{" "}
                        {moment(credential.deletedTimestamp).format(
                          "YYYY-MM-DD h:mm A",
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </AdminTable>
      </div>
    );
  }

  return <div>loading...</div>;
}

export interface GuestCredentialResponse {
  id: string;
  site: {
    id: string;
    name: string;
  } | null;
  type: string;
  credentialId: string;
  credential: string;
  preliminaryCredential: string;
  claimedTimestamp: string | null;
  refreshedTimestamp: string | null;
  deletedTimestamp: string | null;
}

async function getGuestCredentials(guestId: string) {
  const url = `${BASE_API_URL}/api/guest/${guestId}/credentials`;
  const response = await axios.get<GuestCredentialResponse[]>(url);

  return response.data;
}

function useGetGuestCredentials(guestId: string) {
  return useQuery({
    queryKey: ["guests", "credentials", guestId],
    queryFn: () => getGuestCredentials(guestId),
  });
}
